import DahsboardIcon from 'Components/Icons/DashboardIcon';
import AnnouncementIcon from 'Components/Icons/AnnounceIcon';
import QuestionsIcon from 'Components/Icons/QuestionsIcon';
const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard',
            icon: DahsboardIcon,
            breadcrumbs: false
        },
        {
            id: 'announcements',
            title: 'Announcements',
            type: 'item',
            url: '/dashboard/announcements',
            icon: AnnouncementIcon,
            breadcrumbs: false
        },
        {
            id: 'questions',
            title: 'Questions',
            type: 'item',
            url: '/dashboard/questions',
            icon: QuestionsIcon,
            breadcrumbs: false,
            subText: 'outstandingQuestions'
        }
    ]
};

export default dashboard;
